<nz-pagination
  *ngIf="lastPage"
  [nzSimple]="nzSimple"
  [nzTotal]="totalCount || lastPage * perPage"
  [(nzPageIndex)]="page"
  [(nzPageSize)]="perPage"
  (nzPageIndexChange)="pageIndexChange($event)"
  (nzPageSizeChange)="pageSizeChange($event)"
  [nzSize]="'small'"
  [nzShowSizeChanger]="showSizeChanger"
  [nzShowQuickJumper]="showQuickJumper"
  [nzPageSizeOptions]="nzPageSizeOptions"
></nz-pagination>
